// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
// https://gist.github.com/babakness/faca3b633bc23d9a0924efb069c9f1f5

import { useEffect, useRef } from "react";

type IntervalFunction = () => void;

export function useInterval(
  callback: IntervalFunction,
  delayMilliseconds: number | null,
) {
  const savedCallback = useRef<IntervalFunction | null>(null);

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  });

  // Set up the interval. A null delay pauses it.
  useEffect(() => {
    if (delayMilliseconds === null) {
      return undefined;
    }
    function tick() {
      if (savedCallback.current !== null) {
        savedCallback.current();
      }
    }
    const id = setInterval(tick, delayMilliseconds);
    return () => clearInterval(id);
  }, [delayMilliseconds]);
}
